import script from "./board_edit.vue?vue&type=script&setup=true&lang=js"
export * from "./board_edit.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__